import { SIDE_MENU } from "../constants/action-types";

export const getSideMenuList = data => ({
  type: SIDE_MENU,
  payload: data
});
